<template>
  <div class="w-full mx-auto md:container px-2">
    <ul class="list-none relative lg:col-span-2 pt-5 pb-3 lg:pb-5 grid md:grid-cols-2 lg:grid-cols-3 gap-6" role="menu">
      <nav-accessory-card
        v-for="item of visibleCards"
        ref="card"
        :key="item.uid"
        :label="item.linkName"
        :image="item.linkAssetID"
        :qaid="item.uid"
        :description="item.linkDescription"
        :url="composeLink(item.url)"
        :right-function="focusNextElement"
        :left-function="
          (e) => {
            !isCompactView ? focusPreviousElement(e) : focusParentTier();
          }
        "
        :down-function="focusNextElement"
        :up-function="focusPreviousElement"
      />
    </ul>
  </div>
</template>

<script>
import NavAccessoryCard from '@/navigation/NavAccessoryCard.vue';
import {mapState} from 'vuex';
import links from '@/navigation/mixins/links.js';

export default {
  name: 'NavAccessoryCardsLayout',
  components: {
    NavAccessoryCard,
  },
  mixins: [links],
  inject: ['focusParentTier', 'focusNextMenuItem', 'focusPreviousMenuItem'],

  props: {
    navItemData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('global', ['isCompactView']),
    links() {
      const links = [];
      this.$refs.card.forEach((child) => {
        links.push(child.$refs.link);
      });

      return links;
    },
    visibleCards() {
      return (
        this.navItemData?.links?.filter((item) => item?.hasVisibleProducts !== false && item?.visible !== false) || []
      );
    },
  },

  methods: {
    focusNextElement(e) {
      const elIndex = this.links.indexOf(e.target);
      e.target.tabIndex = -1;
      const targetIndex = elIndex < this.links.length - 1 ? elIndex + 1 : 0;
      this.links[targetIndex].tabIndex = 0;
      this.links[targetIndex].focus();
    },
    focusPreviousElement(e) {
      const elIndex = this.links.indexOf(e.target);
      if (elIndex === 0 && !this.isCompactView) {
        this.focusParentTier(e);
        return;
      }
      e.target.tabIndex = -1;
      const targetIndex = elIndex > 0 ? elIndex - 1 : this.links.length - 1;
      this.links[targetIndex].tabIndex = 0;
      this.links[targetIndex].focus();
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-content {
  grid-auto-rows: 40px;

  @media (screen(lg)) {
    grid-template-rows: repeat(auto-fit, 40px);
    grid-auto-flow: column;
    grid-template-columns: calc(1080px / 3);
    max-height: calc(85vh - var(--nav-tier-1-height, 0px));
    min-height: calc(400px + 5rem);

    li {
      width: calc(1080px / 3);
    }
  }
}

.nav-marketing-card {
  width: calc(1080px / 3);
}
</style>
